var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
function useAjax(ajaxFunction, initialValue, initialLoading = false) {
    const [response, setResponse] = React.useState(initialValue);
    const [meta, setMeta] = React.useState({
        loading: initialLoading,
        success: false,
        failure: false,
        message: '',
    });
    function fetchFunction(...args) {
        return __awaiter(this, void 0, void 0, function* () {
            setMeta((prev) => (Object.assign(Object.assign({}, prev), { loading: true })));
            const res = yield ajaxFunction(...args);
            const result = yield res.json();
            if (res.ok) {
                setResponse(result);
            }
            setMeta((prev) => {
                let nextState = Object.assign(Object.assign({}, prev), { loading: false });
                if (res.ok) {
                    nextState.success = true;
                }
                else {
                    nextState.failure = true;
                }
                if (result === null || result === void 0 ? void 0 : result.message) {
                    nextState.message = result.message;
                }
                return nextState;
            });
        });
    }
    function reset() {
        setMeta({ loading: false, success: false, failure: false, message: '' });
    }
    const metaObject = Object.assign(Object.assign({}, meta), { reset });
    return [response, fetchFunction, metaObject];
}
export { useAjax };
